import React, { useState, useEffect } from 'react'
import BackgroundImage from '../../../assets/early/images/BackgroundImage.png'
import { ReactComponent as EmptyButton } from '../../../assets/early/svg/EmptyButton.svg'
import { ReactComponent as ResetIcon } from '../../../assets/early/svg/ResetIcon.svg'
import { ReactComponent as UpstriveMascot } from '../../../assets/early/svg/UpstriveMascot.svg'
import Header from './Header'
import StudentButton from './StudentButton'
import { format } from 'date-fns'
import SingleRowStudent from './SingleRowStudent'
import useOpenStudent from './useOpenStudent'
//import SecretKeyModal from '../modals/SecretKeyModal'
import { Oval } from 'react-loader-spinner'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { getById, loadSingleClassReport, resetClassReport } from '../../../server/server'
import { useQuery } from '../../../utils/util'
import { useLocation } from 'react-router-dom'
import '../../../styles/early/earlyMotion.css'

function EarlyClassroomHome() {
    const query = useQuery()
    const classId = query.get('id')
    const location = useLocation()
    let history = useHistory()
    const [currentClass, setCurrentClass] = useState(location.state?.classInfo ?? {})
    const [students, setStudents] = useState([])
    const [respondedStudents, setRespondedStudent] = useState([])
    const [loading, setLoading] = useState(true)
    const [processReloading, setProcessReloading] = useState(false)
    const [modalVisible, setModalVisible] = useState(false)
    const { t } = useTranslation()
    const openStudent = useOpenStudent()

    useEffect(() => {
        loadReport()
        getClassInfo()
    }, [])

    const loadReport = async () => {
        const data = {
            class_id: classId,
            day_code: format(Date.now(), 'yyyy-MM-dd'),
        }
        const resp = await loadSingleClassReport(data)
        if (resp.status === 200) {
            parseData(resp?.data?.data)
            setLoading(false)
        }
    }

    const getClassInfo = async () => {
        const resp = await getById({ collection: 'class', id: classId })
        if (resp.status == 200) {
            setCurrentClass(resp.data)
        }
    }

    const parseData = (feedbackData) => {
        const numberOfRows = 2
        let arr = []
        const remainingStudents = feedbackData.filter((e) => !!e?.feedback?.empty_data)
        const respondedStudents = feedbackData.filter((e) => !!e?.feedback?.emotion)
        setRespondedStudent(respondedStudents)
        for (let i = 0; i < Math.ceil(remainingStudents.length / numberOfRows); i++) {
            let student = remainingStudents[i * numberOfRows]
            let subArr = [student]

            const secondIndex = i * 2 + 1
            if (secondIndex < remainingStudents.length) subArr.push(remainingStudents[secondIndex])

            arr.push(subArr)
        }
        setStudents(arr)
    }

    const resetReport = async () => {
        setModalVisible(false)
        setProcessReloading(true)
        const data = {
            class_id: classId,
            day_code: format(Date.now(), 'yyyy-MM-dd'),
        }
        const resp = await resetClassReport(data)
        if (resp.status == 200) {
            setProcessReloading(false)
            parseData(resp?.data?.data)
        }
    }

    const openConfirmResetModal = () => {
        resetReport()
        setModalVisible(true)
    }

    return (
        <div className="grid grid-cols-1">
            <div className="w-full min-h-screen bg-cover bg-center bg-no-repeat pb-[15px] flex flex-col em-screen" style={{ backgroundImage: `url(${BackgroundImage})` }}>
                <Header text={`${t('Class')} ${currentClass?.name ?? ''}`} showSettingsButton passingData={currentClass} securityEnabled />
                {!loading && !!students.length && (
                    <div className="flex flex-row gap-[30px] justify-start flex-1 pt-[30px] px-[50px] overflow-x-auto pb-[80px] items-center em-stagger em-stack">
                        {students.map((item, index) => (
                            <SingleRowStudent students={item} />
                        ))}
                    </div>
                )}
                {loading && (
                    <div className="flex h-[580px] items-center justify-center flex-1 em-fade-in">
                        <Oval color="#FDDF6D" secondaryColor="#FDDF6D" strokeWidth={5} />
                    </div>
                )}
                {!loading && !students.length && (
                    <div className="flex flex-col items-center  justify-start flex-1 py-[50px] em-stagger">
                        <UpstriveMascot width={250} className="em-mascot" />
                        <p className="text-[32px] font-bold text-white w-[500px] text-center mt-[25px] em-title-in">{t('Congratulations')}!</p>
                        <p className="text-[32px] font-bold text-white w-[500px] text-center em-title-in">{t('Everyone replied')}!</p>
                    </div>
                )}
                <div className="min-h-[260px] flex flex-col">
                    <div className="bg-[#FDDF6D] shadow-[inset_0px_4px_4px_0px_#00000040] h-[5px] w-full"></div>
                    <div className="flex flex-row items-center justify-between h-[60px] px-[30px] bg-[#FFFFFF24]">
                        <div className="flex flex-row items-baseline gap-[15px] min-w-0">
                            <p className="text-[24px] leading-8 font-bold text-[#ECEBF8]  ">{t('Selected')}</p>
                            {!!respondedStudents.length && <p className="text-[16px] leading-5 font-bold text-[#ECEBF8] truncate">{t('Tap a student to change their emotion')}</p>}
                        </div>
                        <div className="flex flex-row items-center gap-[15px]">
                            <p className="text-[16px] leading-5 font-bold text-[#ECEBF8]  ">{t('Click to move all to top')}</p>
                            <button className="em-tap" style={{ position: 'relative' }} disabled={processReloading || respondedStudents.length == 0} onClick={openConfirmResetModal}>
                                <EmptyButton />
                                <div className="absolute h-[42px] w-[42px] top-0 flex items-center justify-center pb-[2px]">
                                    {processReloading ? <Oval color="white" secondaryColor="white" width={20} height={20} /> : <ResetIcon />}
                                </div>
                            </button>
                        </div>
                    </div>
                    {!respondedStudents.length && !loading && (
                        <div className="flex flex-col items-center justify-center flex-1 py-[50px]">
                            <p className="text-[24px] font-bold text-white w-[500px] text-center">{t('No one replied yet')}!</p>
                        </div>
                    )}
                    {!!respondedStudents.length && !loading && (
                        <div className="flex flex-row gap-[60px] h-[200px] justify-start flex-1 pt-[20px] px-[50px] overflow-x-auto em-stagger em-stagger-pop">
                            {respondedStudents.map((item, index) => (
                                // Always the neutral face: the class screen is shared, so classmates shouldn't see each other's emotions.
                                <StudentButton animal={item?.user?.animal} key={item?.user?.id ?? index} student={item?.user} emotion={'ok'} smaller onClick={openStudent} />
                            ))}
                        </div>
                    )}
                </div>
                {/* <SecretKeyModal modalVisible={modalVisible} setModalVisible={setModalVisible} callbackFunction={resetReport} callbackFunctionType={'reset'} /> */}
            </div>
        </div>
    )
}

export default EarlyClassroomHome
